class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

(() => {
  const SELECTORS = {
    menuWrapper: '.sf-menu-wrapper',
    menu: '.sf-menu-content',
    toggleBtn:   '.js-menu-button',
    openIcon:    '.custom_open_btn',
    closeIcon:   '.custom_close_btn'
  };
  const TRANSITION_FALLBACK_MS = 300;

  const menuWrapper = document.querySelector(SELECTORS.menuWrapper);
  const menu        = document.querySelector(SELECTORS.menu);
  const toggleBtn   = document.querySelector(SELECTORS.toggleBtn);
  const menuBtns = document.querySelectorAll('.new__design_btn');
  const sideMenus = document.querySelectorAll('.custom_side-menu');

    menuBtns.forEach((btn, i) => {
      btn.addEventListener('click', function () {
        sideMenus.forEach((menu) => menu.classList.remove('open-menu'));
        if (sideMenus[i]) {
          sideMenus[i].classList.add('open-menu');
        }
      });
    });

    document.querySelectorAll('.custom__back_btn').forEach((backBtn, i) => {
      backBtn.addEventListener('click', function () {
        if (sideMenus[i]) {
          sideMenus[i].classList.remove('open-menu');
        }
      });
    });

  if (!menuWrapper || !menu || !toggleBtn) {
    console.warn('[menu] Missing one or more required elements. '
      + 'Check SELECTORS.menuWrapper/menu/toggleBtn.');
    return;
  }

  const openIcon  = toggleBtn.querySelector(SELECTORS.openIcon);
  const closeIcon = toggleBtn.querySelector(SELECTORS.closeIcon);

  // Try to read a real transition duration from the sliding panel (first child)
  const slidingPanel = menuWrapper.firstElementChild;
  const transitionDuration = (() => {
    if (!slidingPanel) return TRANSITION_FALLBACK_MS;
    const cs = getComputedStyle(slidingPanel);
    const dur = (cs.transitionDuration || '0s').split(',')[0].trim();
    const delay = (cs.transitionDelay || '0s').split(',')[0].trim();
    const ms = s => s.endsWith('ms') ? parseFloat(s) : parseFloat(s) * 1000;
    const total = (ms(dur) || 0) + (ms(delay) || 0);
    return total || TRANSITION_FALLBACK_MS;
  })();

  function openMenu() {
    // your original behavior:
    menuWrapper.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
    menuWrapper.classList.remove('hidden');
    setTimeout(() => {
      menuWrapper.style.setProperty('--tw-bg-opacity', '0');
      if (menuWrapper.firstElementChild) {
        menuWrapper.firstElementChild.classList.remove('-translate-x-full');
      }
    });
    // keep scroll consistent with typical mobile drawers
    document.documentElement.classList.add('prevent-scroll');
  }

  function closeMenu() {
    // your original behavior:
    menuWrapper.style.setProperty('--tw-bg-opacity', '0');
    if (menuWrapper.firstElementChild) {
      menuWrapper.firstElementChild.classList.add('-translate-x-full');
    }
    setTimeout(() => {
      menuWrapper.classList.add('hidden');
      document.documentElement.classList.remove('prevent-scroll');
      menu.classList.remove('sf-sub-menu-open');
      menu.classList.remove('open-level-1', 'open-level-2'); // Close search
      document.querySelectorAll('.custom__back_btn').forEach((backBtn, i) => {
      backBtn.click();
    });
    }, transitionDuration);
  }

  // Helpers
  const isOpen = () => !menuWrapper.classList.contains('hidden');
  const setIconsForState = (open) => {
    if (openIcon)  openIcon.classList.toggle('hidden', open);
    if (closeIcon) closeIcon.classList.toggle('hidden', !open);
    toggleBtn.setAttribute('aria-expanded', String(open));
  };

  // Initial state (assumes menu is closed if wrapper has .hidden)
  setIconsForState(isOpen());

  // Keep the CSS var up to date for viewport height
  const setVH = () => menuWrapper.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
  setVH();
  window.addEventListener('resize', setVH);

  // Bind the toggle click (idempotent)
  if (!toggleBtn.dataset.boundMenuToggle) {
    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (isOpen()) {
        closeMenu();
        setIconsForState(false);
      } else {
        openMenu();
        setIconsForState(true);
      }
    }, { passive: false });
    toggleBtn.dataset.boundMenuToggle = 'true';
  }

  // Close when clicking the backdrop (if you want this UX)
  menuWrapper.addEventListener('click', (e) => {
    if (e.target === menuWrapper && isOpen()) {
      closeMenu();
      setIconsForState(false);
    }
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) {
      closeMenu();
      setIconsForState(false);
    }
  });
})();
